<template>
  <div class="login" v-loading="loading">
    <div class="layer1"></div>
    <div class="layer2"></div>
    <div class="layer3"></div>
    <div class="layer4"></div>
    <div class="layer5"></div>
    <div class="title"></div>
    <img class="emoji" style="transform: translateY(-50%) rotateY(180deg)" :src="emoji1" alt=""/>
    <img class="emoji" style="left: 66%;"
         :src="emoji2" alt=""/>
    <el-form @submit.native.prevent :rules="rules" ref="loginForm" :model="loginForm"
             class="loginContainer">
      <h3 class="loginTitle">
        用户登录
      </h3>
      <el-form-item prop="phone">
        <el-input type="text" v-model="loginForm.phone" placeholder="亲，请输入用户名">
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="loginForm.password" placeholder="亲，请输入密码">
        </el-input>

      </el-form-item>
      <!--      <el-checkbox v-model="checked" class="loginRemember">一周之内记住我</el-checkbox>-->
      <el-button type="primary"
                 style="width:100%"
                 @click="submitLogin">登录
      </el-button>
    </el-form>
    <!--    备案-->

    <div class="footer">
      <span><a style="color:#989898;text-decoration: none" href="https://beian.miit.gov.cn/"
               target="_blank">ICP备案/许可证号：冀ICP备2022022529号-1</a></span>
      <div>|</div>
      <span style="display: flex;align-items: center">
        <img style="width: 17px;margin-right: 4px" alt=""
             src="../../public/c6c6840b95d51b1b406880fb0c56883.png"/>
        <a style="color:#989898;text-decoration: none" href=
          "https://beian.mps.gov.cn/#/query/webSearch?code=13040302001442"
           rel="noreferrer" target="_blank">冀公网安备13040302001442</a></span>
    </div>
  </div>
</template>

<script>
import {postAction} from "@/util/request";
import emoji1 from '@/assets/images/emoji1.png';
import emoji2 from '@/assets/images/emoji2.png';

export default {
  name: "Login",
  data() {
    return {
      emoji1,
      emoji2,
      loading: false,
      captchaUrl: "",
      loginForm: {
        phone: "",
        password: ""
      },
      checked: false,
      rules: {
        phone: [{required: true, message: "请输入用户名", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
      },
    }
  },
  created() {
    document.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.submitLogin()
      }
    })
  },
  methods: {
    submitLogin() {
      let data = this.loginForm
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          postAction("people/login", data)
            .then((res) => {
              if (res.success) {
                this.loading = false
                //登录成功 将token放入local中，进行页面跳转携带参数
                window.localStorage.setItem("token", res.result.token);
                this.$store.commit('updateObj', res.result.obj)
                this.$router.replace("/Index")
              } else {
                this.$message.warning(res.message);
                return
              }
            }).catch(e => {
            this.$message.error("登录失败，请重试")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@use "sass:string";
@use "sass:math";

.login {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  //background: rgba(0, 0, 0, 0) url("../assets/images/img.webp") repeat;
  //background-size: 100% 100%;
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
}

.title {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  text-align: center;
  font-family: 'lato', sans-serif;
  font-weight: 300;
  font-size: 50px;
  letter-spacing: 10px;
  margin-top: -60px;
  padding-left: 10px;
  background: linear-gradient(white, #38495a);
  background-clip: text;
  -webkit-background-clip: text;
}

// 用阴影创建多个星星的函数
@function createShadow($n) {
  $shadow: '#{math.random(100)}vw #{math.random(100)}vh #fff';
  @for $i from 2 through $n {
    $shadow: '#{$shadow}, #{math.random(100)}vw #{math.random(100)}vh #fff'
  }
  // 去掉引号
  @return string.unquote($shadow);
}

// 设置初始的星星数量和动画持续时间
$count: 1000;
$duration: 400;

// 循环5层
@for $i from 1 through 5 {
  // 每层数量减半
  $count: math.floor(calc($count / 2));
  // 星星越大（近）移动越快
  $duration: math.floor(calc($duration / 2));

  .layer#{$i} {
    // 控制星星大小
    $size: #{$i}px;
    position: fixed;
    top: 0px;
    left: 0px;
    width: $size;
    height: $size;
    border-radius: 50%;
    // 用阴影创建多个星星
    box-shadow: createShadow($count);
    // 设置动画
    animation: moveUp #{$duration}s linear infinite;
    // 设置子元素，让layer离开屏幕底部后还有星星出现
    &::after {
      content: '';
      position: fixed;
      left: 0;
      // 子元素在视口底部
      top: 100vh;
      // 继承父元素
      width: inherit;
      height: inherit;
      border-radius: inherit;
      box-shadow: inherit;
    }
  }
}


@keyframes moveUp {
  100% {
    // 星星往上移动一个视口
    transform: translateY(-100vh);
  }
}

.loginContainer {
  border-radius: 15px;
  background-clip: padding-box;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  padding: 15px 35px 15px 35px;
  background: rgba(0, 0, 0, 0.5); // 改为半透明深色背景
  border: 1px solid rgba(92, 92, 255, 0.5); // 调整为更柔和的边框
  box-shadow: 0 0 15px rgba(248, 133, 255, 0.5); // 调整阴影颜色
  color: #fff; // 确保文字在深色背景上清晰

  ::v-deep .el-input__inner {
    background-color: rgba(255, 255, 255, 0.1); // 输入框半透明背景
    border: 1px solid rgba(255, 255, 255, 0.3); // 输入框边框调整
    color: #fff; // 输入文字颜色

    &::placeholder {
      color: #ccc; // placeholder文字颜色
    }
  }
}

.loginContainer::before {
  content: '';
  position: absolute;
  display: block;
  top: -56%;
  left: 50%;
  transform: translateX(-50%);
  background-image: url("../assets/images/top.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 450px;
  aspect-ratio: 5/3;

}

.loginTitle {
  margin: 0 auto 48px auto;
  text-align: center;
  font-size: 40px;
  color: #fff; // 标题文字颜色
  opacity: 0;
}

.loginRemember {
  text-align: left;
  margin: 0px 0px 15px 0px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 60px;
  position: fixed;
  bottom: 0;
  background-color: #333333;
  color: #989898;
}

.footer span {
  display: block;
  text-align: center;
  margin: 0 7px;
}

.emoji {
  width: 20%;
  aspect-ratio: 1/1;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 14%;
}
</style>
